import React from 'react';
import {Platform, View} from 'react-native';
import Modal from 'react-native-modal';
import {isFunction, noop} from 'lodash';

import {white} from '/theme/color/on.color';
import {nullComponentDefault} from '/util/defaultProps.util';

import ReportRecordDefaultLoading from '../ReportRecordDefaultLoading';

interface ReportRecordDataProviderProps {
  hasReportRecordData: boolean;
  reportRecordData: any;
  fetchReportRecord: () => void;
  dataRenderer: React.ElementType;
  dataRendererProps: Record<string, any>;
  popoverReady: any;
  popoverIsShadow: boolean;
  popoverUpdateHeight: () => void;
  onShowWithRecordData: () => void;
}

class ReportRecordDataProvider extends React.PureComponent<ReportRecordDataProviderProps> {
  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentDidMount() {
    const {
      popoverReady = {},
      popoverIsShadow = false,
      hasReportRecordData = false,
      fetchReportRecord = noop,
      onShowWithRecordData = noop,
    } = this.props;

    if (!popoverIsShadow) {
      (isFunction(popoverReady.then) ? popoverReady : Promise.resolve()).then(
        () => {
          if (!hasReportRecordData) {
            fetchReportRecord();
          } else {
            onShowWithRecordData();
          }
        },
      );
    }
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentDidUpdate(prevProps: ReportRecordDataProviderProps) {
    const {hasReportRecordData: hadReportRecordData} = prevProps;
    const {
      hasReportRecordData = false,
      fetchReportRecord = noop,
      popoverUpdateHeight = noop,
      onShowWithRecordData = noop,
    } = this.props;

    if (hadReportRecordData && !hasReportRecordData) {
      fetchReportRecord();
    } else if (!hadReportRecordData && hasReportRecordData) {
      popoverUpdateHeight();
      onShowWithRecordData();
    }
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  render() {
    const {
      hasReportRecordData = false,
      reportRecordData = null,
      dataRenderer: DataRenderer = nullComponentDefault,
      dataRendererProps = {},
      popoverIsShadow = false,
    } = this.props;

    const content = hasReportRecordData ? (
      <DataRenderer
        {...dataRendererProps}
        reportRecordData={reportRecordData}
      />
    ) : (
      <ReportRecordDefaultLoading {...dataRendererProps} />
    );

    // On web, if it's the actual content (not the shadow measurer), wrap it in a Modal for the drawer effect
    if (Platform.OS === 'web' && !popoverIsShadow) {
      const popoverClose = dataRendererProps?.popoverClose || noop;
      return (
        <Modal
          isVisible={true}
          onBackdropPress={popoverClose}
          onBackButtonPress={popoverClose}
          style={{
            margin: 0,
            justifyContent: 'flex-start',
            alignItems: 'flex-end',
          }}
          animationIn="slideInRight"
          animationOut="slideOutRight"
          useNativeDriver
          hideModalContentWhileAnimating>
          <View
            style={{
              backgroundColor: white,
              width: 500,
              height: '100%',
            }}>
            {content}
          </View>
        </Modal>
      );
    }

    return content;
  }
}

export default ReportRecordDataProvider;
